import * as Yup from 'yup';
import { useMemo } from 'react';
import Inputmask from 'inputmask';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import LoadingButton from '@mui/lab/LoadingButton';

import { useSnackbar } from 'src/components/snackbar';
import FormProvider, {
  RHFTextField,
} from 'src/components/hook-form';

import RHFDatePicker from './RHFDatepicker';

// ----------------------------------------------------------------------

export default function CheckReceivedForm({
  currentRequest,
  openCloseModal,
  refreshData,
}) {

  const { enqueueSnackbar } = useSnackbar();

  const EditStateSchema = Yup.object().shape({
    nameRecieved: Yup.string().required("Se ncesita nombre de quién lo recibió"),
    IdentificationRecieved: Yup.string().required("Se necesita identificación"),
    RecievedDate: Yup.string().required("Se necesita fecha")
  });

  const defaultValues = useMemo(
    () => ({
      nameRecieved: currentRequest?.recievedName?.name,
      IdentificationRecieved: currentRequest?.recievedName?.identification,
      RecievedDate: new Date(currentRequest?.receivedDate)
    }),
    [currentRequest],
  );

  const methods = useForm({
    resolver: yupResolver(EditStateSchema),
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;


  const onSubmit = handleSubmit(async (data) => {
    // TODO: VERIFICAR CON RONEL
    console.log(data, `checkId${currentRequest?.checkId}`);
    enqueueSnackbar('Estado actualizado exitosamente!');
    reset();
    openCloseModal?.onFalse();
  });

  return (
    <FormProvider methods={methods} onSubmit={onSubmit}>
      <Grid xs={12} md={8} justifyContent="center" mb={3}>
        <Stack mb={6} mt={1} spacing={3}>
      
         <Typography typography="subtitle1" sx={{pl: 1}}>Recibido</Typography>
          <RHFTextField name="nameRecieved" label="¿Quién lo recibió?"/>
          <Stack display="flex" columnGap={2} flexDirection="row">
          <RHFTextField
                        name="IdentificationRecieved"
                        label="Identificación"
                        inputProps={{
                          ref: (input) => {
                            if (input && !input.dataset.masked) {
                              Inputmask({
                                mask: "999-9999999-9",
                                placeholder: "_",
                                clearMaskOnLostFocus: false,
                                removeMaskOnSubmit: true,
                                autoUnmask: true,
                              }).mask(input);
                              input.dataset.masked = "true";

                              // Opcional: posicionar cursor al final del input
                              setTimeout(() => {
                                const length = input.value?.length || 0;
                                input.setSelectionRange(length, length);
                              }, 0);
                            }
                          },
                        }}
                      />
          <RHFDatePicker name="RecievedDate" label="¿Cuándo se recibió?"/>
          </Stack>
        </Stack>
        <Stack justifyContent="flex-end" direction="row" sx={{ mt: 3, mb: 3 }} spacing={2}>
          <Button
            onClick={() => {
              openCloseModal?.onFalse();
              refreshData();
            }}
            variant="contained"
            color="error"
            sx={{width: "30%"}}
          >
            Cancelar
          </Button>
          <LoadingButton type="submit" variant="contained" loading={isSubmitting} color="success" fullWidth>
            Guardar 
          </LoadingButton>
        </Stack>
      </Grid>
    </FormProvider>
  );
}

CheckReceivedForm.propTypes = {
  currentRequest: PropTypes.object,
  openCloseModal: PropTypes.object,
  refreshData: PropTypes.func,
};
